module.exports = __webpack_public_path__ + "img/hezu.ca7dbc35.png";